// this file generate by script, don't modify it manually!!!
export enum I18nKey {
  WORKSPACE$TITLE = "WORKSPACE$TITLE",
  WORKSPACE$FLOW_EDITOR_TAB_LABEL = "WORKSPACE$FLOW_EDITOR_TAB_LABEL",
  WORKSPACE$PLANNER_TAB_LABEL = "WORKSPACE$PLANNER_TAB_LABEL",
  WORKSPACE$MARKDOWN_EDITOR_TAB_LABEL = "WORKSPACE$MARKDOWN_EDITOR_TAB_LABEL",
  WORKSPACE$CODE_EDITOR_TAB_LABEL = "WORKSPACE$CODE_EDITOR_TAB_LABEL",
  WORKSPACE$BROWSER_TAB_LABEL = "WORKSPACE$BROWSER_TAB_LABEL",
  WORDSPACE$HELP_TAB_LABEL = "WORDSPACE$HELP_TAB_LABEL",
  WORKSPACE$PLAN_TAB_LABEL = "WORKSPACE$PLAN_TAB_LABEL",
  PLANNER$EMPTY_MESSAGE = "PLANNER$EMPTY_MESSAGE",
  WORKSPACE$NEW_SESSION = "WORKSPACE$NEW_SESSION",
  WORKSPACE$TODAY = "WORKSPACE$TODAY",
  WORKSPACE$YESTERDAY = "WORKSPACE$YESTERDAY",
  WORKSPACE$PREVIOUS_SEVEN_DAYS = "WORKSPACE$PREVIOUS_SEVEN_DAYS",
  WORKSPACE$PREVIOUS_THIRTY_DAYS = "WORKSPACE$PREVIOUS_THIRTY_DAYS",
  WORKSPACE$PREVIOUS_PREVIOUS_ONE_YEAR = "WORKSPACE$PREVIOUS_PREVIOUS_ONE_YEAR",
  WORKSPACE$OLDER_THAN_ONE_YEAR = "WORKSPACE$OLDER_THAN_ONE_YEAR",
  USER_PROFILE$HELP_AND_FEEDBACK = "USER_PROFILE$HELP_AND_FEEDBACK",
  USER_PROFILE$SETTING = "USER_PROFILE$SETTING",
  USER_PROFILE$SIGN_OUT = "USER_PROFILE$SIGN_OUT",
  SETTING$GENERAL = "SETTING$GENERAL",
  SETTING$USER = "SETTING$USER",
  SETTING$ORGANIZATION = "SETTING$ORGANIZATION",
  SETTING$INTERATIONS = "SETTING$INTERATIONS",
  SETTING$INDEXERS = "SETTING$INDEXERS",
  SETTING$THEME = "SETTING$THEME",
  SETTING$LANGUAGE = "SETTING$LANGUAGE",
  SETTING$NAME = "SETTING$NAME",
  SETTING$USER_NAME = "SETTING$USER_NAME",
  SETTING$EMAIL = "SETTING$EMAIL",
  SETTING$PASSWORD = "SETTING$PASSWORD",
  SETTING$SET_PASSWORD = "SETTING$SET_PASSWORD",
  SETTING$SET_SSO = "SETTING$SET_SSO",
  SETTING_BUTTON$CHANGE_EMAIL = "SETTING_BUTTON$CHANGE_EMAIL",
  SETTING_BUTTON$CHANGE_PASSWORD = "SETTING_BUTTON$CHANGE_PASSWORD",
  SETTING_BUTTON$SET_UP = "SETTING_BUTTON$SET_UP",
  SETTING_BUTTON$DELETE_ACCOUNT = "SETTING_BUTTON$DELETE_ACCOUNT",
  CONFIGURATION$CURIE_WORKSPACE_DIRECTORY_INPUT_LABEL = "CONFIGURATION$CURIE_WORKSPACE_DIRECTORY_INPUT_LABEL",
  CONFIGURATION$CURIE_WORKSPACE_DIRECTORY_INPUT_PLACEHOLDER = "CONFIGURATION$CURIE_WORKSPACE_DIRECTORY_INPUT_PLACEHOLDER",
  SETTINGS$MODAL_TITLE = "SETTINGS$MODAL_TITLE",
  CONFIGURATION$MODAL_SUB_TITLE = "CONFIGURATION$MODAL_SUB_TITLE",
  CONFIGURATION$MODEL_SELECT_LABEL = "CONFIGURATION$MODEL_SELECT_LABEL",
  CONFIGURATION$MODEL_SELECT_PLACEHOLDER = "CONFIGURATION$MODEL_SELECT_PLACEHOLDER",
  CONFIGURATION$AGENT_SELECT_LABEL = "CONFIGURATION$AGENT_SELECT_LABEL",
  CONFIGURATION$AGENT_SELECT_PLACEHOLDER = "CONFIGURATION$AGENT_SELECT_PLACEHOLDER",
  CONFIGURATION$LANGUAGE_SELECT_LABEL = "CONFIGURATION$LANGUAGE_SELECT_LABEL",
  CONFIGURATION$LANGUAGE_SELECT_PLACEHOLDER = "CONFIGURATION$LANGUAGE_SELECT_PLACEHOLDER",
  CONFIGURATION$MODAL_CLOSE_BUTTON_LABEL = "CONFIGURATION$MODAL_CLOSE_BUTTON_LABEL",
  CONFIGURATION$MODAL_SAVE_BUTTON_LABEL = "CONFIGURATION$MODAL_SAVE_BUTTON_LABEL",
  CONFIGURATION$MODAL_RESET_BUTTON_LABEL = "CONFIGURATION$MODAL_RESET_BUTTON_LABEL",
  CONFIGURATION$SETTINGS_NEED_UPDATE_MESSAGE = "CONFIGURATION$SETTINGS_NEED_UPDATE_MESSAGE",
  CONFIGURATION$AGENT_LOADING = "CONFIGURATION$AGENT_LOADING",
  CONFIGURATION$AGENT_RUNNING = "CONFIGURATION$AGENT_RUNNING",
  LOAD_SESSION$MODAL_TITLE = "LOAD_SESSION$MODAL_TITLE",
  LOAD_SESSION$MODAL_CONTENT = "LOAD_SESSION$MODAL_CONTENT",
  LOAD_SESSION$RESUME_SESSION_MODAL_ACTION_LABEL = "LOAD_SESSION$RESUME_SESSION_MODAL_ACTION_LABEL",
  LOAD_SESSION$START_NEW_SESSION_MODAL_ACTION_LABEL = "LOAD_SESSION$START_NEW_SESSION_MODAL_ACTION_LABEL",
  CHAT_INTERFACE$INITIALZING_AGENT_LOADING_MESSAGE = "CHAT_INTERFACE$INITIALZING_AGENT_LOADING_MESSAGE",
  CHAT_INTERFACE$INPUT_PLACEHOLDER = "CHAT_INTERFACE$INPUT_PLACEHOLDER",
  CHAT_INTERFACE$INPUT_SEND_MESSAGE_BUTTON_CONTENT = "CHAT_INTERFACE$INPUT_SEND_MESSAGE_BUTTON_CONTENT",
  CHAT_INTERFACE$ASSISTANT = "CHAT_INTERFACE$ASSISTANT",
  SETTINGS$MODEL_TOOLTIP = "SETTINGS$MODEL_TOOLTIP",
  SETTINGS$AGENT_TOOLTIP = "SETTINGS$AGENT_TOOLTIP",
  SETTINGS$LANGUAGE_TOOLTIP = "SETTINGS$LANGUAGE_TOOLTIP",
  SETTINGS$DISABLED_RUNNING = "SETTINGS$DISABLED_RUNNING",
  CODE_EDITOR$LOADING_MESSAGE = "CODE_EDITOR$LOADING_MESSAGE",
  ORGANIZATION$INVITE_MEMBER = "ORGANIZATION$INVITE_MEMBER",
  ORGANIZATION_BUTTON$COPY_LINK = "ORGANIZATION_BUTTON$COPY_LINK",
  ORGANIZATION$MEMBERS = "ORGANIZATION$MEMBERS",
  ORGANIZATION_TABLE$NAME = "ORGANIZATION_TABLE$NAME",
  ORGANIZATION_TABLE$ROLE = "ORGANIZATION_TABLE$ROLE",
  ORGANIZATION_TABLE$EMAIL = "ORGANIZATION_TABLE$EMAIL",
  INTERGRATION$GITHUB = "INTERGRATION$GITHUB",
  INTERGRATION$JIRA = "INTERGRATION$JIRA",
  INTERGRATION$SLACK = "INTERGRATION$SLACK",
  INTERGRATION_BUTTON$CONNECT = "INTERGRATION_BUTTON$CONNECT",
  INTERGRATION_BUTTON$CONNECTED = "INTERGRATION_BUTTON$CONNECTED",
  INTERGRATION_BUTTON$CONFIGURE = "INTERGRATION_BUTTON$CONFIGURE",
  USERFORM_CHANGE_PWD_MODAL$MODAL_TITLE = "USERFORM_CHANGE_PWD_MODAL$MODAL_TITLE",
  USERFORM_CHANGE_PWD_MODAL$INPUT_NEW_PASSWORD = "USERFORM_CHANGE_PWD_MODAL$INPUT_NEW_PASSWORD",
  USERFORM_CHANGE_PWD_MODAL$INPUT_NEW_PASSWORD_PLACEHOLDER = "USERFORM_CHANGE_PWD_MODAL$INPUT_NEW_PASSWORD_PLACEHOLDER",
  USERFORM_CHANGE_PWD_MODAL$CONFIRM_PASSWORD = "USERFORM_CHANGE_PWD_MODAL$CONFIRM_PASSWORD",
  USERFORM_CHANGE_PWD_MODAL$CONFIRM_PASSWORD_PLACEHOLDER = "USERFORM_CHANGE_PWD_MODAL$CONFIRM_PASSWORD_PLACEHOLDER",
  USERFORM_CHANGE_PWD_MODAL$ERROR_MESSAGE = "USERFORM_CHANGE_PWD_MODAL$ERROR_MESSAGE",
  USERFORM_CHANGE_PWD_MODAL$CONFIRM_BUTTON = "USERFORM_CHANGE_PWD_MODAL$CONFIRM_BUTTON",
  USERFORM_DELETE_ACCOUNT_MODEL$MODAL_TITLE = "USERFORM_DELETE_ACCOUNT_MODEL$MODAL_TITLE",
  USERFORM_DELETE_ACCOUNT_MODEL$MODAL_CONTENT = "USERFORM_DELETE_ACCOUNT_MODEL$MODAL_CONTENT",
  USERFORM_DELETE_ACCOUNT_MODEL$DELETE_BUTTON = "USERFORM_DELETE_ACCOUNT_MODEL$DELETE_BUTTON",
}
